import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PLAYERS_ADDITIONAL_ROUTE_NAME,
  ADMIN_PLAYERS_LIST_ROUTE_NAME,
  PLAYERS_PERMISSIONS,
  TRANSLATION_ADMIN_PLAYERS,
} from '@modules/players/constants';
import { PlayerProfileModule } from '@modules/players/submodules/PlayerProfile/PlayerProfileModule';
import { getTranslationKeys } from '@modules/players/translations';
import {
  ADMIN_PLAYERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

export class PlayersModule extends AppModule {
  protected submodules = [
    new PlayerProfileModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_PLAYERS_ADDITIONAL_ROUTE_NAME,
      path: 'players',
      permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'PlayersListPage',
    });

    router.addChildRoute(ADMIN_PLAYERS_ADDITIONAL_ROUTE_NAME, {
      name: ADMIN_PLAYERS_LIST_ROUTE_NAME,
      path: '',
      permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
      component: () => import('@modules/players/pages/PlayersListPage/PlayersListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PLAYERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PLAYERS_PLAYERS_LIST'),
      to: {
        name: ADMIN_PLAYERS_LIST_ROUTE_NAME,
      },
      permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
      id: ADMIN_PLAYERS_LIST_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_ADMIN_PLAYERS, getTranslationKeys);
  }
}
